import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus';
import 'element-plus/theme-chalk/index.css';
import locale from 'element-plus/lib/locale/lang/zh-cn'
import axios from './utils/http'//引入axios方法
import VueClipBoard from 'vue-clipboard2'//vue中实现复制内容到剪切板

/* 路由发生变化修改页面title */
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})


const app = createApp(App)
app.provide('$http', axios)//把axios方法添加到Vue框架原型链上
app.use(router).use(ElementPlus, { locale }).use(VueClipBoard).mount('#app')
